import { notification } from 'antd'

export const showWarningNotification = message => {
  notification.warning({
    message: 'Advertencia',
    duration: null,
    description: message,
  })
}
